import { useEffect, useState } from "react";
import { Card, Flex, Typography } from "antd";
import dayjs from "dayjs";
import jalaliPlugin from "jalali-plugin-dayjs";
import "dayjs/locale/fa";
import "./Watch.css";

dayjs.extend(jalaliPlugin);
dayjs.locale("fa");

const { Text } = Typography;

const Watch: React.FC = () => {
  const [now, setNow] = useState(dayjs());

  useEffect(() => {
    const id = setInterval(() => setNow(dayjs()), 1000);
    return () => clearInterval(id);
  }, []);

  const jalaliDate = now.calendar("jalali").format("D MMMM YYYY");
  const jalaliDay = now.calendar("jalali").format("dddd");
  const time = now.format("HH:mm:ss");

  return (
    <Card className="watch-card">
      <Flex vertical align="center" gap={8}>
        <Text className="watch-time">{time}</Text>
        <Text className="watch-date">
          <Text strong className="watch-day">
            {jalaliDay}
          </Text>{" "}
          {jalaliDate}
        </Text>
      </Flex>
    </Card>
  );
};

export default Watch;